import { InputAdornment } from "@mui/material";
import { M_InputTextField } from "../../../../M_Components";
import { NumericFormat } from "react-number-format";
import '../item.css'
import { useTranslation } from "react-i18next";

// JavaScript safe integer limit
const MAX_SAFE_INTEGER = 9007199254740991;
const MIN_SAFE_INTEGER = -9007199254740991;

export const NumericFieldItemForm = ({ field, changeValueCallback, itemForm, isDecimalField, isDisabled }) => {
    const [t, i18n] = useTranslation();
    const currentLanguage = i18n.resolvedLanguage;

    const handleInputChange = (value) => {
        // Allow empty value
        if (value === "" || value === null || value === undefined) {
            changeValueCallback({
                ...itemForm,
                form: {
                    ...itemForm.form,
                    [field.Code]: null
                }
            });
            return;
        }

        // For integer fields, reject decimal separators
        if (!isDecimalField && typeof value === 'string' && (value.includes(".") || value.includes(","))) {
            return;
        }

        // Normalize comma to dot for decimal processing
        const normalizedValue = String(value).replace(',', '.');

        // Allow valid numeric format (including trailing dot for decimal input)
        if (!/^-?\d*\.?\d*$/.test(normalizedValue)) {
            return;
        }

        // Check if value exceeds JavaScript safe integer limits (prevent scientific notation)
        const numericCheck = parseFloat(normalizedValue);
        if (!isNaN(numericCheck) && !normalizedValue.endsWith('.')) {
            if (numericCheck > MAX_SAFE_INTEGER || numericCheck < MIN_SAFE_INTEGER) {
                return; // Silently reject without error message
            }
        }

        // For decimal fields, validate decimal places
        if (isDecimalField && field.DecimalDigits != null) {
            const parts = normalizedValue.split('.');
            if (parts.length === 2 && parts[1].length > field.DecimalDigits) {
                return;
            }
        }

        // For storage, convert to proper numeric type
        let finalValue;
        if (isDecimalField) {
            // For decimal fields, store as number (not string)
            // Allow partial input like "123." during typing
            if (normalizedValue.endsWith('.')) {
                finalValue = normalizedValue; // Keep as string during typing
            } else if (normalizedValue === '' || normalizedValue === '-') {
                finalValue = normalizedValue; // Keep partial input
            } else {
                finalValue = parseFloat(normalizedValue);
                // Validate it's a valid number
                if (isNaN(finalValue)) {
                    return;
                }
            }
        } else {
            // For integer fields, store as integer
            if (normalizedValue === '' || normalizedValue === '-') {
                finalValue = normalizedValue;
            } else {
                finalValue = parseInt(normalizedValue, 10);
                if (isNaN(finalValue)) {
                    return;
                }
            }
        }

        changeValueCallback({
            ...itemForm,
            form: {
                ...itemForm.form,
                [field.Code]: finalValue
            }
        });
    }

    return (
        <div className="numeric">
            <M_InputTextField
                fullWidth
                label={field.Captions[currentLanguage]?.length > 0 ? field.Captions[currentLanguage] : field.Code}
                required={field.IsMandatory}
                type="text"
                value={itemForm.form[field.Code] ?? ''}
                disabled={isDisabled}
                onChange={(e) => handleInputChange(e.target.value)}
                placeholder={
                    isDecimalField && field.DecimalDigits != null
                        ? `Max ${field.DecimalDigits} decimal places`
                        : undefined
                }
                helperTextMessage={
                    isDecimalField && field.DecimalDigits != null
                        ? `Maximum ${field.DecimalDigits} decimal places allowed`
                        : undefined
                }
            />

        </div>
    );
}